import React, { useMemo } from "react";
import MainHeading from "../../../components/ui/MainHeading";
import { useSelector } from "react-redux";
import { authSelector } from "../../../services/redux/slices/authSlice";
import SanctionedDisbursed from "./SanctionedDisbursed";
import TermLoanDashboard from "../termLoan/TermLoanDashboard";
import MainHeadingLoans from "../../../components/ui/MainHeadingLoans";
import { RootState } from "../../../services/redux/store";
import NoLoansFound from "../NoLoansFound";

const MainDashboard = () => {
  const { loanCategory } = useSelector(authSelector);
  const { Flexi, TermLoan } = loanCategory;

  // Define state for the selected toggle
  const [alignment, setAlignment] = React.useState("Term Loan");

  const tabType = useSelector((state: RootState) => state.tabs.tabType);

  const componentToRender = useMemo(() => {
    if ((tabType === "Term Loan" || tabType == null) && TermLoan.length > 0) {
      return <TermLoanDashboard />;
    } else if (tabType === "Flexi Term Loan" && Flexi.length > 0) {
      return <SanctionedDisbursed />;
    } else if (Flexi.length === 0 && TermLoan.length === 0) {
      return <NoLoansFound />;
    } else {
      return <SanctionedDisbursed />;
    }
  }, [alignment, Flexi, TermLoan, tabType]);

  // Determine which component to load based on the alignment state
  // let componentToRender;
  // if (alignment === "Term Loan" && TermLoan.length > 0) {
  //   componentToRender = <TermLoanDashboard />;
  // } else if (alignment === "Flexi Term Loan" && Flexi.length > 0) {
  //   componentToRender = <SanctionedDisbursed />;
  // } else if (Flexi.length === 0 && TermLoan.length === 0) {
  //   componentToRender = <div>No loans available.</div>; // Placeholder for no loans
  // } else {
  //   componentToRender = <SanctionedDisbursed />; // Default fallback
  // }

  return (
    <div>
      <MainHeadingLoans
        setToggle={setAlignment} // Pass the setAlignment function
      />
      {componentToRender}
    </div>
  );
};

export default MainDashboard;
